import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Input, Checkbox } from 'antd';
import withTranslations from 'app/components/HOGs/withTranslations';
import { isMobile } from 'app/middleware/hooks';
// eslint-disable-next-line import/no-unresolved
import CloseButton from 'app/components/Utility/closeButton';

import { map, tileLayer, Polyline } from 'leaflet';

import { mapTourPoly } from 'app/components/Desctop/Map/map_tour_poly_utils';
import { getMarker } from 'app/libs/markers/getTourPoint';
import LOGO from 'static/img/Tourstart_Logo.svg';
import LOGO_PICT from 'static/img/logo_tourstart_42.png';

let init = false;

const EmbedTourModal = ({ open, setOpen, tr }) => {
  const title = useSelector((store) => store.tourFullData.data.title);
  const id = useSelector((store) => store.tourFullData.data.id);

  const points = useSelector(
    (store) => store.tourFullData.activeMultiPart.points
  );

  const poly = useSelector((store) => store.tourFullData.activeMultiPart.poly);

  const mainLogo = isMobile(1024) ? LOGO_PICT : LOGO;

  // const [valueRadio, setValueRadio] = useState(1);
  const [width, setWidth] = useState('640');
  const [height, setHeight] = useState('400');
  const [keep, setKeep] = useState(false);
  const [mapLayout, setMapLayout] = useState(null);

  const ref = useRef(null);
  const refMap = useRef(null);
  // const onChangeRadio = (e) => setValueRadio(e.target.value);

  const onChangeKeep = (e) => {
    setKeep(e.target.checked);
    if (e.target.checked) {
      setWidth(height * 1.6);
    }
  };

  const onChangeWidth = (value) => {
    setWidth(value);
    if (keep) {
      setHeight(value / 1.6);
    }
  };

  const onChangeHeight = (value) => {
    setHeight(value);
    if (keep) {
      setWidth(value * 1.6);
    }
  };

  const handleCancel = () => setOpen(false);

  const getClass = () => 'embedMapLayout green';

  const getAreaValue = () => {
    return `<iframe width="${width}" height="${height}" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://tourstart.org/tourembed/_${id}"></iframe>`;
  };

  const getMap = () => {
    let lat = 50.56011;
    let lng = 15.05722;
    let polyline = null;
    if (poly) {
      const style = {
        opacity: 0.9,
        weight: 6,
        color: '#652C95',
      };
      polyline = new Polyline(mapTourPoly.strToLanLngArray(poly || ''), style);
      lat = polyline.getBounds().getCenter().lat;
      lng = polyline.getBounds().getCenter().lng;
    }

    const config = {
      navigationControl: false,
      disableDefaultUI: true,
      scaleControl: false,
      zoomControl: true,
      zoom: 3,
      minZoom: 2,
      center: [lat, lng],
      dragging: false,
      scrollWheelZoom: false,
      layers: [
        tileLayer('https://tiles.tourstart.org/{z}/{x}/{y}.png', {
          attribution: 'Tourstart',
        }),
      ],
    };

    init = true;

    const m = map(refMap.current, config);

    m.fitBounds(polyline.getBounds());

    if (polyline) {
      polyline.addTo(m);
    }

    if (points) {
      points.forEach((point) => {
        const p = getMarker({ customId: point.id, point }, 'drive', {});
        p.addTo(m);
      });
    }
    setMapLayout(m);
  };

  useEffect(() => {
    if (open && refMap.current && !init) {
      getMap();
    }
  }, [open]);

  useEffect(() => {
    return () => {
      if (mapLayout) mapLayout.remove();
      if (init) init = false;
    };
  }, []);

  return (
    <Modal
      visible={open}
      title={false}
      footer={false}
      onCancel={handleCancel}
      wrapClassName="embedModal"
      width={360}
      closeIcon={<CloseButton />}
    >
      <div className="embedModalLayout">
        <div className={getClass()}>
          <div className="title">{title}</div>
          <div id="mapEmbed" className="mapEmbed" ref={refMap} />
        </div>

        <div className="embedLogoLayout">
          <div className="subText">{tr['Powered by']}</div>
          <div className="logo">
            <img src={mainLogo} alt="logo" />
          </div>
        </div>

        <div className="embedText">
          <p>{tr['In this embed option...']}</p>
        </div>

        <div className="embedSettingsLayout">
          <div className="size">
            <div className="width">
              <span className="title">{`${tr.Width}:`}</span>
              <Input
                value={width}
                onChange={(e) => onChangeWidth(e.target.value)}
                className="input"
              />
              <span>px</span>
            </div>
            <div className="height">
              <span className="title">{`${tr.Height}:`}</span>
              <Input
                value={height}
                onChange={(e) => onChangeHeight(e.target.value)}
                className="input"
              />
              <span>px</span>
            </div>
          </div>
          <div className="ratio">
            <Checkbox onChange={onChangeKeep} checked={keep} />
            <span className="text">{tr['keep ratio']}</span>
          </div>
          {/* <div className="design">
            <Radio.Group onChange={onChangeRadio} value={valueRadio}>
              <Space direction="vertical">
                <Radio value={1}>
                  <div className="green">{tr.Text}</div>
                </Radio>
                <Radio value={2}>
                  <div className="purple">{tr.Text}</div>
                </Radio>
              </Space>
            </Radio.Group>
          </div> */}
        </div>

        <div className="embedHtml">
          <div className="title">
            {tr['Paste the HTML to embed into a website']}
          </div>
          <Input.TextArea rows={4} ref={ref} value={getAreaValue()} />
          <div
            className="empty"
            onClick={() => {
              ref.current.focus({
                cursor: 'all',
              });
            }}
            aria-hidden
          />
        </div>
      </div>
    </Modal>
  );
};

export default withTranslations(EmbedTourModal);
